import React from 'react';
export var Tick = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { width: "11", height: "8", viewBox: "0 0 11 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1 4.21171L2.42917 6.22979C2.61717 6.50922 2.99724 6.58409 3.27807 6.39703C3.33433 6.35955 3.38396 6.31304 3.42492 6.25939L9.5 1", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default Tick;
